/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";

import {
  AnyProductType,
  productTypeAccessory,
} from "../../constants/productTypes";
import { useSearchForm } from "../../stores/hooks/useSearchForm";
import { Chassis } from "./Chassis";
import { PartNumber } from "./PartNumber";
import {
  Tabs,
  tabChassis,
  tabPartNubmer,
  tabTireSize,
  tabVehicle,
  tabVin,
} from "./Tabs";
import { TireSize } from "./TireSize";
import { Vehicle } from "./Vehicle";
import { Vin } from "./Vin";

const map = {
  [tabChassis]: Chassis,
  [tabPartNubmer]: PartNumber,
  [tabTireSize]: TireSize,
  [tabVehicle]: Vehicle,
  [tabVin]: Vin,
};

type Props = {
  compact?: boolean;
  forcePrimaryManufacturers?: boolean;
  productType?: AnyProductType;
};

export const SearchFormLanding: FunctionComponent<Props> = ({
  compact,
  forcePrimaryManufacturers,
  productType,
}) => {
  const [{ activeTab }] = useSearchForm();
  const vehicleOnly = productType === productTypeAccessory;
  const Component = vehicleOnly ? Vehicle : map[activeTab];
  return (
    <section
      className={clsx("tw-landing-form", compact && "tw-landing-form--compact")}
    >
      {!vehicleOnly && <Tabs className="mx-auto" compact={compact} />}
      <div className="rounded-panel lg:rounded-button-group p-3 sm:p-6 lg:p-4">
        {Component === Vehicle ? (
          <Vehicle
            forcePrimaryManufacturers={forcePrimaryManufacturers}
            productType={productType}
          />
        ) : (
          <Component />
        )}
      </div>
    </section>
  );
};

/**
 * @see docs/worklog/TW-891/TW-891-standalone-accessories-site/rfc.md
 * @see docs/worklog/TW-891/TW-891-standalone-accessories-site/tfc.md
 * @see docs/worklog/TW-914-standalone-accessories-site-changes/rfc.md
 * @see docs/worklog/TW-914-standalone-accessories-site-changes/tfc.md
 */
